import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormField, FormItem, FormLabel, FormDescription } from '@/components/ui/form'
import type { ObjectFormData } from '../schema'

interface ObjectPictureTabProps {
    form: UseFormReturn<ObjectFormData>
}

export function ObjectPictureTab({ form }: ObjectPictureTabProps) {
    const { t } = useTranslation()

    return (
        <div className="space-y-4">
            <FormField
                control={form.control}
                name="ObjectImage"
                render={() => (
                    <FormItem>
                        <FormLabel>{t('objects.objectImage')}</FormLabel>
                        <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
                            <p className="text-muted-foreground">
                                {t('objects.objectImagePlaceholder')}
                            </p>
                            <FormDescription className="mt-2">
                                {t('objects.objectImageDescription')}
                            </FormDescription>
                        </div>
                    </FormItem>
                )}
            />
        </div>
    )
}
